<template>
	<div id="app">
		<loading ref="loading"></loading>
		<transition name="page" mode="out-in" v-if="$auth.ready()">
			<component v-if="layout" :is="layout"></component>
		</transition>
		<div v-if="!$auth.ready()">
			<semantic-loading :active="true" :text="$t('globals.loaders.loading')"></semantic-loading>
		</div>
	</div>
</template>

<script>
import Loading from './Loading'
import size from 'lodash/size'

// Load layout components dynamically.
const requireContext = require.context('../layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
	.map(file =>
		[file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
	)
	.reduce((components, [name, component]) => {
		components[name] = component
		return components
	}, {})

export default {
	components: {
		Loading
	},

  watch: {
	  '$auth.watch.data': {
	    deep: true,
	    immediate: true,
      handler(v) {
	      if (v) {
	        try {
            window.__insp.push(['identify', v.email]);
            window.__insp.push(['tagSession', {email: v.email}]);
          } catch (e) {

          }

        }
      }
    },
    '$route': {
	    deep: true,
      immediate: true,
      handler() {
        try {
          window.__insp.push(['pageUrl', location.href]);
        } catch (e) {

        }
      }
    }
  },

	metaInfo () {
		const appName = 'Zietwing'

		return {
			title: appName,
			titleTemplate: `%s · ${appName}`
		}
	},

	data: () => ({
		layout: null,
		defaultLayout: 'app'
	}),

	mounted () {
		this.$loading = this.$refs.loading
	},

	methods: {
		/**
		* Set the application layout.
		*
		* @param {String} layout
		*/
		setLayout (layout) {
			if (!layout || !layouts[layout]) {
				layout = this.defaultLayout
			}

			this.layout = layouts[layout].default
		}
	},

	onIdle () {
		if (size(this.$auth.user()) > 0) {
			this.$auth.logout()
		}
	}
}
</script>

<style>
	.page-enter-active,
	.page-leave-active {
		transition: opacity .2s;
	}
	.page-enter,
	.page-leave-to {
		opacity: 0;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .15s
	}
	.fade-enter,
	.fade-leave-to {
		opacity: 0
	}
</style>



// WEBPACK FOOTER //
// src/components/App.vue